<app-application-steps [currentStep]="4" [isDetailsView]="true" [showTechnicalFormFirst]="true"></app-application-steps>

<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div *ngIf="!isLoading" class="component-container" id="print-form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ 'grid-comp.grid-comp-assessment' | translate }}
      <span>- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId$ | async }}</span>
    </div>
  </div>

  <ng-container *ngIf="applicationId$ | async as applicationId">
    <form class="form-section form-font-size">
      <app-grid-compatibility-assessment-result
        [applicationId]="applicationId"
        [isModerator]="true"
        (resultFormChange)="resultData = $event"
        (executedProcessAction)="executedProcessAction($event, applicationId)"></app-grid-compatibility-assessment-result>

      <app-order-history
        [applicationId]="applicationId"
        [pagination]="true"
        [useDefaultCls]="false"
        class="order-history"></app-order-history>

      <div class="text-right-align top-margin send-message-section">
        <button label="Download" pButton (click)="downloadAllDocuments(applicationId)"></button>
        <button class="action-button" label="Print" pButton (click)="print(applicationId)"></button>
      </div>

      <div class="ui-g-12 submit-button-section">
        <button
          type="button"
          (click)="router.navigate(['gridcomp', 'documents', applicationId])"
          class="ui-button mr-3"
          label="{{ 'grid-comp.back' | translate | uppercase }}"
          pButton></button>

        <button
          type="button"
          (click)="saveResultData(applicationId)"
          [disabled]="!resultData"
          class="ui-button-save mr-3"
          label="{{ 'grid-comp.save' | translate | uppercase }}"
          pButton></button>
      </div>
    </form>
  </ng-container>
</div>
